module.exports = __webpack_public_path__ + "img/law4.c80d461f.webp";